export default __webpack_public_path__ + "static/media/2443.1fb19427.png";